import { render, staticRenderFns } from "./reportedTickets.vue?vue&type=template&id=2736dc54&scoped=true&"
import script from "./reportedTickets.vue?vue&type=script&lang=js&"
export * from "./reportedTickets.vue?vue&type=script&lang=js&"
import style0 from "./reportedTickets.vue?vue&type=style&index=0&id=2736dc54&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2736dc54",
  null
  
)

export default component.exports